﻿import { useEffect } from 'react';
import { euclideanDistance } from '../SliderUtils';
import { useSliderContext } from '../SliderContext';

type UseTouchProps = {
  updateIndex: (newIndex: number, forceUpdate?: boolean) => void
}

const useTouch = ({ updateIndex }: UseTouchProps) => {
  const { root, tiles } = useSliderContext();

  // eslint-disable-next-line no-restricted-globals
  const findNewIndex = (event: Event) => {
    const list = (event.target as HTMLElement)?.querySelector('ul');
    if (!list || !root.current) return;
    const rootRect = root.current.getBoundingClientRect();

    let closest = 0;
    let distanceToCenter = Number.MAX_SAFE_INTEGER;
    const sliderCenter = rootRect.left + (rootRect.width / 2);
    for (let i = 0; i < tiles.current.length; i++) {
      const tile = tiles.current[i];
      const tileRect = tile?.getBoundingClientRect();
      if (!tileRect) return;

      const currentDistance = euclideanDistance({
        x: sliderCenter,
        y: 0
      }, {
        x: tileRect.left + (tileRect.width / 2),
        y: 0
      });

      if (currentDistance < distanceToCenter) {
        distanceToCenter = currentDistance;
        closest = i;
      }
    }

    updateIndex(closest, false);
  };

  useEffect(() => {
    if (!root.current) return;

    root.current.addEventListener('scroll', findNewIndex);

    return () => {
      root.current?.removeEventListener('scroll', findNewIndex);
    };
  }, [root]);
};

export default useTouch;